export const isObject = (value: any) => value !== null && typeof value === 'object';
